/* eslint-disable */

export const prepearedVolumeBuy = {
    GET_PREPEARED_VOLUME_BUY_REQUEST: 'GET_PREPEARED_VOLUME_BUY_REQUEST',
    GET_PREPEARED_VOLUME_BUY_SUCCESS: 'GET_PREPEARED_VOLUME_BUY_SUCCESS',
    GET_PREPEARED_VOLUME_BUY_FAILURE: 'GET_PREPEARED_VOLUME_BUY_FAILURE',
};
